// extracted by mini-css-extract-plugin
export var root = "K_vD";
export var wrapper = "K_vF";
export var image = "K_vG d_w d_y d_W";
export var imageWithHeight = "K_vH";
export var crop = "K_vJ";
export var round = "K_vK";
export var fixedHeight = "K_vL";